import HomeIcon from "@mui/icons-material/Home";
import SearchIcon from "@mui/icons-material/Search";
import GamepadIcon from "@mui/icons-material/Gamepad";
import PlagiarismIcon from "@mui/icons-material/Plagiarism";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { ReactNode } from "react";
import { PERMISSIONS } from "../../constants";
import ROUTES from "../../routes/constants";
import { LD_FLAGS, LDFlagKey } from "../launchdarkly/flags";

export interface SidebarNestedItem {
  title: string;
  href: string;
  icon?: ReactNode;
  nested?: boolean;
  requiredPermission: string;
  ldFlag?: LDFlagKey;
}

export interface SidebarItem extends SidebarNestedItem {
  id: string;
  nestedNavigation?: SidebarNestedItem[];
}

export interface SidebarElements {
  mainItems: SidebarItem[];
  adminItems: SidebarItem[];
}

const sidebarElements: SidebarElements = {
  mainItems: [
    {
      id: "home",
      title: "Home",
      icon: <HomeIcon />,
      href: "/",
      requiredPermission: PERMISSIONS.VIEW_ADMIN,
    },
    {
      id: "search",
      title: "Search",
      icon: <SearchIcon />,
      href: ROUTES.SEARCH,
      requiredPermission: PERMISSIONS.VIEW_SEARCH,
    },
    {
      id: "data-cleaning",
      title: "Data Cleaning",
      icon: <CleaningServicesIcon />,
      href: ROUTES.DATA_CLEANING,
      requiredPermission: PERMISSIONS.VIEW_WATCHLIST,
      ldFlag: LD_FLAGS.SHOW_DATA_CLEANSING,
    },
    {
      id: "tasks",
      title: "Tasks",
      icon: <AccessAlarmIcon />,
      href: ROUTES.TASKS,
      requiredPermission: PERMISSIONS.VIEW_ADMIN,
    },
    {
      id: "status",
      title: "Status",
      icon: <MonitorHeartIcon />,
      href: ROUTES.STATUS,
      requiredPermission: PERMISSIONS.VIEW_ADMIN,
    },
    {
      id: "mda",
      title: "Mda",
      icon: <DescriptionOutlinedIcon />,
      href: ROUTES.MDA,
      requiredPermission: PERMISSIONS.VIEW_WATCHLIST,
      ldFlag: LD_FLAGS.SHOW_MDA,
    },
    {
      id: "watchlist",
      title: "Watch List",
      icon: <PlagiarismIcon />,
      href: ROUTES.WATCH_LIST,
      requiredPermission: PERMISSIONS.VIEW_WATCHLIST,
      ldFlag: LD_FLAGS.SHOW_WATCH_LIST,
    },
  ],
  adminItems: [
    {
      id: "admin",
      title: "Admin",
      icon: <AdminPanelSettingsIcon />,
      href: "/admin",
      requiredPermission: PERMISSIONS.VIEW_ADMIN,
      nestedNavigation: [
        {
          title: "Control Panel",
          icon: <GamepadIcon />,
          href: "/admin/control-panel",
          requiredPermission: PERMISSIONS.VIEW_ADMIN,
          nested: true,
          ldFlag: LD_FLAGS.SHOW_CONTROL_PANEL,
        },
        {
          title: "Client Configuration",
          icon: <SupervisorAccountIcon />,
          href: ROUTES.ADMIN.CLIENTS,
          requiredPermission: PERMISSIONS.VIEW_ADMIN,
          nested: true,
          ldFlag: LD_FLAGS.SHOW_CLIENT_CONFIG,
        },
      ],
    },
  ],
};

export default sidebarElements;
